import {Box, styled} from '@mui/material';

export const StyledDistrictGrid = styled(Box)`
	display: grid;
	flex-wrap: wrap;
	grid-template-columns: 1fr;
	gap: 16px;

	${({theme}) => theme.breakpoints.up('lg')} {
		column-gap: 24px;
		grid-template-columns: repeat(2, 1fr);
	}
`;
